module.exports = __webpack_public_path__ + "img/video_THOld.1fe278bc.png";